import { EntityCatalog } from 'src/app/shared/components/entity-catalog/entity-catalog.types';

/** Curated list an operator picks from; a typo here cannot reach a task config. */
export const LLM_MODEL_CATALOG: EntityCatalog = {
  title: 'LLM Models',
  singular: 'LLM Model',
  idKey: 'id',
  statusFieldKey: 'is_active',
  searchPlaceholder: 'Search model name, provider…',
  fields: [
    {
      key: 'model_name',
      label: 'Model name',
      kind: 'text',
      inList: true,
      required: true,
      immutable: true,
      placeholder: 'gpt-4o-mini',
      hint: 'Exactly as the provider expects it.',
    },
    { key: 'display_name', label: 'Display name', kind: 'text', inList: true, required: true },
    { key: 'provider', label: 'Provider', kind: 'text', inList: true, placeholder: 'openai' },
    { key: 'is_active', label: 'Active', kind: 'boolean', inList: true },
    { key: 'notes', label: 'Notes', kind: 'text' },
  ],
};
